// extracted by mini-css-extract-plugin
export default {"groupForm":"SingleWorkTableCreateModal_groupForm__-csEu"};